import React, { useEffect, useRef } from 'react'
import { TransparentLoader } from '../../Loader/transparentLoader.component';

export const ModalConfirmacionSucursal = ({ variable, setVariable, setShowModal }) => {

    const myRef = useRef();
    let block = false;

    useEffect(() => {
        document.addEventListener('click', handleClickOutside, true);
        return () => {
            document.removeEventListener('click', handleClickOutside, true);
        };
    }, [])

    const handleClickOutside = (event) => {
        if (
            myRef.current &&
            !myRef.current.contains(event.target)
        ) {
            block == false
                &&
                setShowModal(false);
        }
    };

    return (
        <>
            <div className="background">
                &nbsp;&nbsp;
            </div>
            <div className="modalNotificacion sucursalConfimacion" ref={myRef}>
                {
                    variable
                        ?
                        <TransparentLoader />
                        :
                        <>
                            <div className="modalAlerta">
                                <div
                                    className="option-cerrar"
                                    onClick={() => setShowModal(false)}
                                >
                                    <h1>Cerrar</h1>
                                    <i className="fas fa-times"> </i>
                                </div>
                                <div className="head">
                                    <b>Ten en cuenta:</b>
                                </div>
                                <div className="descripcion">
                                    Al cambiar la dirección puede variar la disponibilidad y los precios de los productos.
                                </div>
                            </div>
                            <div className="botones-alerta">
                                <button
                                    className="btn-alerta1"
                                    onClick={
                                        () => {
                                            block = true
                                            setVariable(true);
                                            // setShowModal(false);
                                        }
                                    }
                                >Aceptar</button>
                                <button
                                    className="btn-alerta2"
                                    onClick={() => setShowModal(false)}
                                >Cancelar</button>
                            </div>
                        </>
                }

            </div>
        </>
    )
}
